import { render, staticRenderFns } from "./WorldCat.vue?vue&type=template&id=756e7394&"
import script from "./WorldCat.vue?vue&type=script&lang=js&"
export * from "./WorldCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports